export default __webpack_public_path__ + "static/media/jhon.8bcfe623.jpg";